import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Murphy's Giving Market in the News Page (Media)
const MediaPage = () => {
  const newsStories = [
    {
      headline: "Feeding the soul: Creating a lifeline for families in hard times",
      source: "CBS Sunday Morning",
      image: "https://i.ytimg.com/vi/mAt2sXurd5Q/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=mAt2sXurd5Q"
    },
    {
      headline: "SNAP benefits paused: Murphy's Giving Market in Upper Darby steps up to help residents",
      source: "FOX 29 Philadelphia",
      image: "https://static-media.fox.com/fmcv3/prod/fts/erbvsdiaevm57hav/lm8aabsp86c3ucs9.jpg",
      link: "https://www.fox29.com/video/1733599"
    },
    {
      headline: "Philly-area pantries see a surge as reduced SNAP payouts could face 'significant delays'",
      source: "Philadelphia Inquirer",
      image: "https://www.inquirer.com/resizer/v2/2E6SZ73JKFHV5IXXHWUFFTJWLQ.jpg?auth=78382cb98710f65ab0a0a920e1d62cd703986424ce4e743860c2268c898de53c&width=760&height=507&smart=true",
      link: "https://www.inquirer.com/news/snap-benefits-november-update-shutdown-20251103.html"
    }
  ];

  return (
    <div data-testid="in-the-news-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/58fx1mn1_PXL_20251002_171138270.jpg"
        alt="Murphy's Giving Market in the News"
      />

      {/* News Stories Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="in-the-news-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-12"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Murphy's Giving Market in the News
            </h1>
            
            <div className="space-y-8">
              {newsStories.map((story, index) => (
                <motion.div
                  key={story.headline}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
                >
                  <div className="aspect-video w-full overflow-hidden">
                    <img 
                      src={story.image} 
                      alt={story.headline}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <p className="text-[#C41E3A] text-sm font-medium mb-2">{story.source}</p>
                    <h3 
                      className="font-bold text-[#1A1A1A] text-xl mb-4"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {story.headline}
                    </h3>
                    <a 
                      href={story.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`news-link-${index}`}
                      className="text-[#C41E3A] hover:text-[#a31830] font-medium inline-flex items-center gap-1 transition-colors"
                    >
                      Click here for more
                      <ChevronRight size={16} />
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MediaPage;
